(
	function( $ ) {
		'use strict';

		$( window ).on( 'load', function() {
			$( '.constellation-wrapper' ).each( function() {
				var id = $( this ).attr( 'id' );

				var lineColor = $( this ).data( 'line-color' ) ? $( this ).data( 'line-color' ) : '#ffffff',
				    lineAlpha = $( this ).data( 'line-alpha' ) ? $( this ).data( 'line-alpha' ) : '1',
				    starColor = $( this ).data( 'star-color' ) ? $( this ).data( 'star-color' ) : '#ffffff',
				    starAlpha = $( this ).data( 'star-alpha' ) ? $( this ).data( 'star-alpha' ) : '1';

				particlesJS( id, {
					'particles': {
						'number': {
							'value': 80,
							'density': {
								'enable': true,
								'value_area': 800
							}
						},
						'color': {
							'value': starColor
						},
						'shape': {
							'type': 'circle',
							'stroke': {
								'width': 0,
								'color': '#000000'
							},
							'polygon': {
								'nb_sides': 5
							},
							'image': {
								'src': 'img/github.svg',
								'width': 100,
								'height': 100
							}
						},
						'opacity': {
							'value': starAlpha,
							'random': false,
							'anim': {
								'enable': false,
								'speed': 1,
								'opacity_min': 0.1,
								'sync': false
							}
						},
						'size': {
							'value': 3,
							'random': true,
							'anim': {
								'enable': false,
								'speed': 40,
								'size_min': 0.1,
								'sync': false
							}
						},
						'line_linked': {
							'enable': true,
							'distance': 150,
							'color': lineColor,
							'opacity': lineAlpha,
							'width': 1
						},
						'move': {
							'enable': true,
							'speed': 6,
							'direction': 'none',
							'random': false,
							'straight': false,
							'out_mode': 'out',
							'bounce': false,
							'attract': {
								'enable': false,
								'rotateX': 600,
								'rotateY': 1200
							}
						}
					},
					'interactivity': {
						'detect_on': 'canvas',
						'events': {
							'onhover': {
								'enable': true,
								'mode': 'grab'
							},
							'onclick': {
								'enable': false,
								'mode': 'push'
							},
							'resize': true
						},
						'modes': {
							'grab': {
								'distance': 140,
								'line_linked': {
									'opacity': 1
								}
							},
							'bubble': {
								'distance': 400,
								'size': 40,
								'duration': 2,
								'opacity': 8,
								'speed': 3
							},
							'repulse': {
								'distance': 200,
								'duration': 0.4
							},
							'push': {
								'particles_nb': 4
							},
							'remove': {
								'particles_nb': 2
							}
						}
					},
					'retina_detect': true
				} );
			} );
		} );
	}( window.jQuery )
);
